// VIP功能配置
export const VIP_CONFIG = {
  // VIP等级配置
  levels: {
    vip: {
      name: 'VIP会员',
      icon: 'el-icon-star-on',
      iconColor: '#ffd700',
      price: 0, // 从后端获取
      features: [
        '查看报价人信息',
        '原料采购专区询价单可置顶',
        '原料供应专区产品可置顶',
        '专属客服支持',
        '优先处理订单'
      ],
      badge: null
    },
    svip: {
      name: 'SVIP会员',
      icon: 'el-icon-star-on',
      iconColor: '#ff6b35',
      price: 0, // 从后端获取
      features: [
        '享受VIP所有特权',
        '原料供应专区产品可置顶\n' +
        '展示SVIP供应商信息',
        '报价时查看采购商信息',
        '升级为优质供应商标识',
        '增加曝光',
      ],
      badge: '尊享版'
    }
  },

  // VIP功能权限配置
  permissions: {
    vip: {
      priceDiscount: 0.95, // 5%折扣
      priorityOrder: true,
      supplierContact: true,
      customerService: true,
      priorityQuotation: true
    },
    svip: {
      priceDiscount: 0.90, // 10%折扣
      priorityOrder: true,
      supplierContact: true,
      customerService: true,
      priorityQuotation: true,
      dedicatedAdvisor: true,
      freeSample: true,
      exclusiveEvents: true,
      priorityProductInfo: true
    }
  },

  // VIP状态检查方法
  checkVipStatus(userInfo) {
    if (!userInfo || userInfo.vip_status !== 1) {
      return { isVip: false, level: null };
    }

    const level = userInfo.vip_level || 'vip';
    return { isVip: true, level };
  },

  // 检查特定功能权限
  hasPermission(userInfo, permission) {
    const { isVip, level } = this.checkVipStatus(userInfo);
    if (!isVip) return false;

    return this.permissions[level] && this.permissions[level][permission];
  },

  // 获取价格折扣
  getPriceDiscount(userInfo) {
    const { isVip, level } = this.checkVipStatus(userInfo);
    if (!isVip) return 1;

    return this.permissions[level]?.priceDiscount || 1;
  },

  // 获取VIP等级信息
  getLevelInfo(level) {
    return this.levels[level] || null;
  },

  // 获取所有VIP等级
  getAllLevels() {
    return Object.keys(this.levels);
  }
};

export default VIP_CONFIG;
